import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';

import {loadJson} from '../utils/loadjson';
const viMessage = loadJson( '/assets/vi.json');
const enMessage = loadJson( '/assets/en.json');

const queryParams = new URLSearchParams(window.location.search);
const lang = queryParams.get('lang');

const homeLayout = loadJson( '/assets/home.json');
const initLang = homeLayout.initLang;
const initMessage = viMessage;

const persistConfig = {
  key: '@web-khoa-ou',
  storage,
  whitelist: ['user', 'intl', 'app'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const initialState = {
  intl: {
    locale: initLang,
    messages: initMessage,
  },
};

const store = createStore(
  persistedReducer,
  initialState,
  composeEnhancers(
    applyMiddleware(thunk),
  )
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);


export const persistor = persistStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js